// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.einheiten-table-wrapper {
    overflow-x: auto;
    margin-top: 1rem;
    margin-bottom: 1.5rem;
}

.einheiten-table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    background-color: var(--hellgruen);
    border-radius: 12px;
    overflow: hidden;
}

.einheiten-table thead th {
    background-color: var(--dunkelgruen);
    color: var(--blassgruen);
    font-size: calc(1rem + 2px);
}

.einheiten-table th,
.einheiten-table td {
    padding: 0.75rem;
    text-align: center;
    border: none;
    font-family: 'Circular', sans-serif;
    font-weight: normal;
}

.einheiten-table th {
    font-family: 'Staatliches', sans-serif;
}

.einheiten-table td {
    font-family: 'Circular', sans-serif;
    font-size: calc(1rem - 2px);
    color: var(--dunkelgruen);
}

.einheiten-table th:first-child,
.einheiten-table td:first-child {
    text-align: left;
}

.einheiten-table tbody tr:nth-child(even) {
    background-color: var(--blassgruen);
}

.error-message {
    color: red;
}

.success-message {
    color: green;
}

/* Drei-Zustand-Steuerung: Automatik / Manuell geöffnet / Gesperrt */
.ea-description {
  font-family: 'Circular', sans-serif;
  color: var(--dunkelgruen);
  max-width: 640px;
  margin: 0 auto 1.5rem;
  text-align: center;
}

.ea-status-buttons {
  display: flex;
  gap: 6px;
  justify-content: center;
}

.ea-status-btn {
  padding: 8px 12px;
  border: 2px solid var(--dunkelgruen);
  background: transparent;
  color: var(--dunkelgruen);
  border-radius: 8px;
  cursor: pointer;
  font-family: 'Staatliches', sans-serif;
  text-transform: uppercase;
}

.ea-status-btn.active {
  background: var(--dunkelgruen);
  color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/arbeit/einheitenaktivieren/EinheitenAktivieren.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,iBAAiB;IACjB,kCAAkC;IAClC,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,wBAAwB;IACxB,2BAA2B;AAC/B;;AAEA;;IAEI,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,mCAAmC;IACnC,mBAAmB;AACvB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,mCAAmC;IACnC,2BAA2B;IAC3B,yBAAyB;AAC7B;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA,oEAAoE;AACpE;EACE,mCAAmC;EACnC,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,sCAAsC;EACtC,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,WAAW;AACb","sourcesContent":[".einheiten-table-wrapper {\n    overflow-x: auto;\n    margin-top: 1rem;\n    margin-bottom: 1.5rem;\n}\n\n.einheiten-table {\n    width: 100%;\n    border-collapse: separate;\n    border-spacing: 0;\n    background-color: var(--hellgruen);\n    border-radius: 12px;\n    overflow: hidden;\n}\n\n.einheiten-table thead th {\n    background-color: var(--dunkelgruen);\n    color: var(--blassgruen);\n    font-size: calc(1rem + 2px);\n}\n\n.einheiten-table th,\n.einheiten-table td {\n    padding: 0.75rem;\n    text-align: center;\n    border: none;\n    font-family: 'Circular', sans-serif;\n    font-weight: normal;\n}\n\n.einheiten-table th {\n    font-family: 'Staatliches', sans-serif;\n}\n\n.einheiten-table td {\n    font-family: 'Circular', sans-serif;\n    font-size: calc(1rem - 2px);\n    color: var(--dunkelgruen);\n}\n\n.einheiten-table th:first-child,\n.einheiten-table td:first-child {\n    text-align: left;\n}\n\n.einheiten-table tbody tr:nth-child(even) {\n    background-color: var(--blassgruen);\n}\n\n.error-message {\n    color: red;\n}\n\n.success-message {\n    color: green;\n}\n\n/* Drei-Zustand-Steuerung: Automatik / Manuell geöffnet / Gesperrt */\n.ea-description {\n  font-family: 'Circular', sans-serif;\n  color: var(--dunkelgruen);\n  max-width: 640px;\n  margin: 0 auto 1.5rem;\n  text-align: center;\n}\n\n.ea-status-buttons {\n  display: flex;\n  gap: 6px;\n  justify-content: center;\n}\n\n.ea-status-btn {\n  padding: 8px 12px;\n  border: 2px solid var(--dunkelgruen);\n  background: transparent;\n  color: var(--dunkelgruen);\n  border-radius: 8px;\n  cursor: pointer;\n  font-family: 'Staatliches', sans-serif;\n  text-transform: uppercase;\n}\n\n.ea-status-btn.active {\n  background: var(--dunkelgruen);\n  color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
